export const baseUrl = "/omni3/v1";
